const IE_11_USERAGENT_REGEXP = /MSIE \d|Trident.*rv:/;
export function isIe11() {
  if (typeof navigator !== 'undefined') {
    return IE_11_USERAGENT_REGEXP.test(navigator.userAgent);
  }
  return false;
}